<h1 mat-dialog-title>Notification</h1>
<div mat-dialog-content>
  <p>Your popup content goes here.</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
